import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "./css/index.css";
type Props = {
  link: string;
  state: any;
  style: any;
};

const FixBtn = ({ link, state, style }: Props) => {
  const navigate = useNavigate();
  const NavFix = useCallback(() => {
    navigate(link, { state });
  }, [link, navigate, state]);

  return (
    <button className="common-fix-btn" onClick={NavFix} style={style}>
      수정하기
    </button>
  );
};

export default FixBtn;
